import z from "zod";

export const acceptTermArgsSchema = z.object({
  useTerm: z.object({
    id: z.number().positive("ID do termo deve ser positivo"),
    updatedAt: z.string().min(1, "Data de atualização é obrigatória"),
    accepted: z.boolean()
  }),
  user: z.object({
    id: z.number().positive("ID do usuário deve ser positivo")
  })
});

export const saveTermsAuthorizationArgsSchema = z.object({
  hasWhats: z.boolean(),
  hasSMS: z.boolean(),
  hasEmail: z.boolean(),
  useTerm: z.object({
    id: z.number(),
    updatedAt: z.string()
  }),
  driver: z
    .object({
      id: z.number()
    })
    .optional(),
  user: z
    .object({
      id: z.number()
    })
    .optional(),
  contact: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      fone: z.string(),
      email: z.string(),
      whatsapp: z.boolean()
    })
  )
});
